import { CircleAlert, X } from "lucide-react";
import { motion, useReducedMotion } from "motion/react";
import { Link } from "react-router";
import { bandErledigt, bandLeeren, useBand } from "./bandZustand";
import { UEBERBLENDUNG } from "./federn";

/** F33 (W51, wie Android W46r und iOS): Band oben in der Inhaltsspalte, wenn das Sichern scheitert, nachdem das Blatt
 *  weg ist. Im Fluss (nicht fixed): nach einem Ansichtswechsel steht die neue Ansicht oben, das Band also im Blick. Die
 *  Huelle ist eine Live-Region, die immer dasteht (leer, ohne Hoehe), damit das Einfuegen angesagt wird; `role="alert"`
 *  traegt nur das Band selbst (eine leere Huelle mit dieser Rolle zaehlten bestehende Tests als Meldung). Der Fokus
 *  bleibt, wo er ist. Je Eintrag ein Link zurueck (nimmt den Eintrag weg), „Meldung schließen“ nimmt alle weg. */
export function Band() {
  const eintraege = useBand();
  const ruhig = useReducedMotion();
  return (
    <div aria-live="assertive" className="band rand">
      {eintraege.length > 0 && (
        <motion.div
          role="alert"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={ruhig ? { duration: 0 } : UEBERBLENDUNG}
          // W82 Teil 4 (Vorlage R11 „zustaende“ Band): dichtes Glas mit Rand in Koralle, Symbol vorne, Text in Tinte
          className="band-meldung mt-4 flex flex-wrap items-center gap-x-3 rounded-lg bg-pg-danger-soft py-1 pr-1 pl-4 text-pg-danger"
        >
          <CircleAlert size={20} strokeWidth={1.75} aria-hidden className="band-symbol shrink-0" />
          <p className="t-subheadline min-w-0 flex-1 basis-48 py-2 font-semibold break-words hyphens-auto">Speichern fehlgeschlagen, bitte erneut versuchen</p>
          <span className="flex min-w-0 flex-wrap items-center gap-x-4">
            {eintraege.map((e) => (
              <Link
                key={e.zu}
                to={e.zu}
                onClick={() => bandErledigt(e.zu)}
                className="t-subheadline inline-flex min-h-(--touch) min-w-(--touch) items-center underline underline-offset-2 hover:opacity-70"
              >
                {e.wort}
              </Link>
            ))}
          </span>
          <button
            type="button"
            aria-label="Meldung schließen"
            onClick={bandLeeren}
            className="ml-auto grid size-(--touch) shrink-0 place-items-center rounded-pill hover:opacity-70"
          >
            <X size={20} strokeWidth={1.75} aria-hidden />
          </button>
        </motion.div>
      )}
    </div>
  );
}
